import React from 'react';
import Checkbox from './Checkbox';
import SVGChevron from '../../svg/Chevron';

class CheckboxDropdown extends React.Component {
  render = () => {
    const { options, onChange, title, onClear } = this.props;

    return (
      <div className="checkbox-dropdown">
        <div className="checkbox-dropdown__button">
          <span>{title}</span>
          <span className="chev">
            <SVGChevron className="svg-chev" />
          </span>
        </div>

        <div className="checkbox-dropdown__selections">
          {this.renderCheckboxes(options, onChange)}
          {this.renderClearAll(onClear)}
        </div>
      </div>
    );
  };

  renderCheckboxes = (options, handleChange) => {
    const { disabled } = this.props;

    return options.map(option => {
      let classes = 'checkbox-wrap checkbox--small';
      if (option.class) {
        classes += ` ${option.class}`;
      } else {
        classes += ' checkbox--small-blue';
      }
      return (
        <Checkbox
          name={option.key}
          className={classes}
          placeholder={option.name}
          checked={option.checked}
          key={option.key}
          onChange={handleChange}
          disabled={disabled}
        />
      );
    });
  };

  renderClearAll = onClearHandler => {
    return <button onClick={onClearHandler}>Clear All</button>;
  };
}

export default CheckboxDropdown;



// WEBPACK FOOTER //
// ./src/components/form/CheckboxDropdown.js